import { getOrgOrgId } from "@rubi/api-generated";
import { useQuery } from "@tanstack/react-query";

// `isRequired` stays undefined until the org's setting has loaded, so callers
// can hold off saving rather than treating a failed load as "not required".
export function useRequireInternalUserId(orgId: string): {
  isRequired: boolean | undefined;
  isError: boolean;
} {
  const { data, isError } = useQuery({
    queryKey: ["org-require-internal-user-id", orgId],
    queryFn: async () =>
      (await getOrgOrgId({ path: { org_id: orgId }, throwOnError: true })).data
        .require_internal_user_id,
    enabled: orgId !== "",
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return { isRequired: data, isError };
}
